import _ from 'underscore';

export function InlineSuggestedParamValueSave({
  key,
  view,
  updated,
  editorView,
  field,
  newI18n,
}) {
  const paramValue = updated[field];

  const text = newI18n.getString(_TL_('This dynamic text placeholder is causing one or more parts of your ad to exceed the character limits.'));
  const helpURL = 'http://go.microsoft.com/fwlink?LinkId=534338';
  let error;
  if (field === 'Param1' && paramValue.length > 1024) {
    error = { Param1: `<a href="${helpURL}" target="_apexPlatformHelp">${text}</a>` };
  } else if (field === 'Param2' && paramValue.length > 70) {
    error = { Param2: `<a href="${helpURL}" target="_apexPlatformHelp">${text}</a>` };
  } else if (field === 'Param3' && paramValue.length > 70) {
    error = { Param3: `<a href="${helpURL}" target="_apexPlatformHelp">${text}</a>` };
  }

  if (_.isUndefined(error)) {
    const recommendation = view.grid.gridView.itemWithKey(key);
    if (!_.isNull(recommendation)) {
      _.first(recommendation.Opportunities)[field] = paramValue;

      // Append the current selected one into existing selected ones.
      const selectedKeys = view.grid.gridView.selectedKeys();
      if (!_.contains(selectedKeys, key)) {
        selectedKeys.push(key);
      }
      view.grid.gridView.set({ selection: _.defaults({ selected: selectedKeys }) });
    }
    editorView.trigger('cancel');
  } else if (_.isFunction(editorView.setErrors)) {
    editorView.setErrors(error);
  }
}
